export default __webpack_public_path__ + "static/inc-a711ecabb478b84ade412a08365d948f.svg";